import $api from "@/zapi-frontend/shared/api/axios";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";

export type TReorderProjectDimensionsPayload = {
  orgId: number;
  orderedIds: number[];
};

export function useReorderProjectDimensions(
  options?: UseMutationOptions<void, AxiosError<{ message: string }>, TReorderProjectDimensionsPayload>
) {
  return useMutation({
    mutationKey: ["reorderProjectDimensions"],
    mutationFn: async ({ orgId, orderedIds }: TReorderProjectDimensionsPayload) => {
      await $api.patch(`/organizations/${orgId}/project-dimensions/reorder`, { orderedIds });
    },
    ...options
  });
}
